import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import fetch from '../../utils/fetch';
import { setAlert } from '../../store/alert';
import icons from '../../utils/icons.json';
import { useNavigate } from 'react-router-dom';

function Reset() {
	const navigate = useNavigate()
	const dispatch = useDispatch();

	const webSettings = useSelector(state => state.webSettings.data);

	const [uname, setUsername] = useState('');
	const [loading, setLoading] = useState(false);
	const [response, setResponse] = useState(null);

	function submit(e) {
		e.preventDefault();
		if (loading) return;
		if (uname.trim().length > 0 && uname.trim().length < 30) {
			setLoading(true);
			fetch
				.get('resetLoginPassword', {
					username: uname,
					passlength: 6,
				})
				.then(res => {
					let data = res.list[0];
					if (data) {
						setUsername('');
						setResponse(data);
					} else {
						dispatch(setAlert({ type: 'error', message: 'Username does not exist' }));
					}
					setLoading(false);
				})
				.catch(err => {
					setLoading(false);
					dispatch(setAlert({ type: 'error', message: err.message }));
				});
		} else {
			dispatch(setAlert({ type: 'error', message: 'Username is invalid' }));
		}
	}

	return (
		<>
			<div className='sign-window shadow'>
				<div className='head'>
					<img className='logo' src={webSettings && webSettings.WEB_SITE_LOGO} alt='' />
					<h2>Reset</h2>
				</div>
				<form className='body' onSubmit={submit}>
					<input onInput={e => setUsername(e.target.value)} className='input' type='text' id='uname' placeholder='Username' value={uname} />
					<button className='btn' type='submit'>
						{loading ? 'Loading...' : 'Reset Password'}
					</button>
				</form>
				<div className='foot'>
					<p className=''>
						Back to <Link to='/signin'>Sign In</Link>
					</p>
				</div>
			</div>
			{!loading && response && (
				<div className='top-window checkout-window'>
					<div className='inner-window'>
						<span className='icon' dangerouslySetInnerHTML={{ __html: icons.check_circle }}></span>
						<h2>SUCCESS</h2>
						<h3>Password Reset</h3>
						<p style={{ margin: '20px auto' }}>Your password was reset. Please check your phone or email you used while registering for this account for verification details.</p>
						<button onClick={() => navigate('/signin')} type='button' className='btn success'>
							Back to Signin
						</button>
					</div>
				</div>
			)}
		</>
	);
}

export default Reset;
